import {
  VIBE_CODING_CLEAR_CONVERSATION_HISTORY_BEGIN,
  VIBE_CODING_CLEAR_CONVERSATION_HISTORY_SUCCESS,
  VIBE_CODING_CLEAR_CONVERSATION_HISTORY_FAILURE,
  VIBE_CODING_CLEAR_CONVERSATION_HISTORY_DISMISS_ERROR,
} from './constants';
import { clearConversation } from '../services/vibeCodingService';

export function clearConversationHistory(args = {}) {
  return async (dispatch) => {
    dispatch({ type: VIBE_CODING_CLEAR_CONVERSATION_HISTORY_BEGIN });
    try {
      const data = await clearConversation(args);
      dispatch({ type: VIBE_CODING_CLEAR_CONVERSATION_HISTORY_SUCCESS, data });
      return data;
    } catch (err) {
      dispatch({
        type: VIBE_CODING_CLEAR_CONVERSATION_HISTORY_FAILURE,
        data: { error: err },
      });
      throw err;
    }
  };
}

export function dismissClearConversationHistoryError() {
  return { type: VIBE_CODING_CLEAR_CONVERSATION_HISTORY_DISMISS_ERROR };
}

export function reducer(state, action) {
  switch (action.type) {
    case VIBE_CODING_CLEAR_CONVERSATION_HISTORY_BEGIN:
      return {
        ...state,
        clearConversationHistoryPending: true,
        clearConversationHistoryError: null,
      };
    case VIBE_CODING_CLEAR_CONVERSATION_HISTORY_SUCCESS:
      return {
        ...state,
        messages: [],
        conversationHistoryHasMore: false,
        conversationHistoryBefore: null,
        conversationId: null,
        clearConversationHistoryPending: false,
        clearConversationHistoryError: null,
        planPending: false,
        planError: null,
        planProposal: null,
        milestones: [],
      };
    case VIBE_CODING_CLEAR_CONVERSATION_HISTORY_FAILURE:
      return {
        ...state,
        clearConversationHistoryPending: false,
        clearConversationHistoryError: action.data.error,
      };
    case VIBE_CODING_CLEAR_CONVERSATION_HISTORY_DISMISS_ERROR:
      return {
        ...state,
        clearConversationHistoryError: null,
      };
    default:
      return state;
  }
}
